module.exports = __webpack_public_path__ + "static/media/map.8425b581.png";